import React, {useEffect, useState} from 'react';
import {useAuth} from '../../../context/auth';
import {Button} from '../../Interface/Forms/Buttons/Button';
import {StepList} from '../../Interface/List/StepList';
import analytics from '@react-native-firebase/analytics';
import {Share} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import Clipboard from '@react-native-clipboard/clipboard';
import {Toast} from '../../Interface/Toast';
import {
  CheckRateTextBold,
  CloseButton,
  CloseButtonIcon,
  Code,
  CodeArea,
  Container,
  ContainerImage,
  CopyCodeButton,
  CopyCodeIcon,
  List,
  ModalBody,
  ModalContent,
  ModalFooter,
  ReferAndWinContainer,
  VehicleBanner,
  VehicleTitle,
} from './styles';

import { useHelpers } from '../../../context/helpers';
import { useGlobal } from '../../../context/global';
import { useBaratinhas } from '../../../hooks/useBaratinhas';


interface Props {
  showModal: boolean;
  onDismiss: () => void;
  data: {
    id: number;
    title?: string;
    imageUrl: any;
    texto: string;
    imageModal: any;
    showIndiqGanhe?: boolean;
    showCadPlaca?: boolean;
    steps?: {id: number; texto: string}[];
  };
}

export function VehiclesModal({showModal, onDismiss, data}: Props) {
  const {user} = useAuth();
  const {handleConfiguraBaratinhas, configuracaoBaratinhas} = useBaratinhas();
  const {formatNumberToLocaleAmount} = useHelpers();
    const {configIndiqueGanhe} = useGlobal();

  const message = `Quer abastecer pagando muito menos? Use meu código (${user.codCompartilhar}) no *Aplicativo Baratão Combustíveis!*\n\nUm app completo com descontos também em oficinas, gás de cozinha, lavagem automotiva, parcelamento de débitos em até 12x e muito mais!💰✨\n\nBaixe agora:\nGoogle Play: https://play.google.com/store/apps/details?id=com.barataoapp&referrer=${user.codCompartilhar}\nApp Store: https://apps.apple.com/app/id1613535824?at=${user.codCompartilhar}\n\nJunte-se a nós e comece a economizar hoje mesmo!
  `;
  const copyToClipboard = () => {
    analytics().logEvent('clica_copiar_codigo_indique_ganhe');
    Clipboard.setString(user.codCompartilhar);
    setShowToast(true);
  };
  async function onShare() {
    analytics().logEvent('clica_compartilhar_indique_e_ganhe');
    try {
      await Share.share({
        message,
      });
    } catch (error) {
      console.log(error);
    }
  }
  const [showToast, setShowToast] = useState(false);

  const [loadingBaratinhas, setLoadingBaratinhas] = useState(true);

    useEffect(() => {
    analytics().logEvent('tela_indique_e_ganhe');
    async function fetchaBaratinhasConfig() {
      try {
        await handleConfiguraBaratinhas();
        setLoadingBaratinhas(false);
      } catch (error) {
        console.log(error);
      }
    }

    fetchaBaratinhasConfig();
  }, []);

    const baratinhasValueResgateMinimo =
    (configuracaoBaratinhas.limiteResgate *
      configuracaoBaratinhas.cotacaoCents) /
    100;

  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      {showToast && (
        <Toast
          type="info"
          text="Código copiado"
          timeout={2000}
          onEnd={() => setShowToast(false)}
        />
      )}
      <CloseButton onPress={onDismiss} activeOpacity={0.7}>
        <CloseButtonIcon name="x" />
      </CloseButton>
      <ContainerImage>
        <VehicleBanner source={data.imageModal} resizeMode="cover" />
      </ContainerImage>
      <ModalContent>
        <ModalBody>
          <VehicleTitle>{data.title}</VehicleTitle>

          <ReferAndWinContainer>
            <List>
              {data.steps &&
                data.steps.map(item => (
                  <StepList number={item.id} text={item.texto} key={item.id} />
                ))}
            </List>
          </ReferAndWinContainer>

          {data.showIndiqGanhe && (
            <ReferAndWinContainer>
              <CheckRateTextBold>Seu código de indicação:</CheckRateTextBold>

              <CodeArea>
                <Code>{user.codCompartilhar}</Code>
                <CopyCodeButton onPress={copyToClipboard} activeOpacity={1}>
                  <CopyCodeIcon name="copy" />
                </CopyCodeButton>
              </CodeArea>

              <CheckRateTextBold>Como funciona: </CheckRateTextBold>
              <List>
                <StepList number={1} text="Copie o código de indicação." />
                <StepList
                  number={2}
                  text="Envie-o para todos os seus amigos!"
                />
                <StepList
                  number={3}
                  text="A cada parcelamento feito por cada amigo indicado, você ganha baratinhaZ!"
                />
                <StepList
                  number={4}
                  text=
                  {` É necessário acumular o valor mínimo de ${loadingBaratinhas ? '••••' : formatNumberToLocaleAmount(
                baratinhasValueResgateMinimo,
              )} em baratinhaZ para
                usá-las como desconto na compra de qualquer produto.`}
                />
                <StepList
                  number={5}
                  text="Alguns cupons promocionais não são válidos para compras com baratinhaZ."
                />
                <StepList
                  number={6}
                 text={`Você pode indicar de ${(configIndiqueGanhe.length > 0  && configIndiqueGanhe[0].limite_indicados) ?? '••••'} a ${(configIndiqueGanhe && configIndiqueGanhe[configIndiqueGanhe.length - 1]?.limite_indicados) ?? '••••'} pessoas. Este limite pode variar de acordo com seu uso do Baratão.`}
                />
              </List>
            </ReferAndWinContainer>
          )}
        </ModalBody>

        <ModalFooter>
          <SafeAreaView>
            {data.showIndiqGanhe ? (
              <Button title="Compartilhar" enabled onPress={onShare} variant="outline" />
            ) : (
              <Button title="Retornar" enabled onPress={onDismiss} variant="outline" />
            )}
          </SafeAreaView>
        </ModalFooter>
      </ModalContent>
    </Container>
  );
}
